import { useQuery } from "@tanstack/react-query";

import { getSoilSightCropDatabase } from "services";

import { useIsAuthenticated } from "utils";

import { GET_SOIL_SIGHT_CROP_DATABASE } from "consts";

import { SoilSightCropDefaultsByCropId } from "models";

// per-crop defaults from the KH-116 dataset.
// When `cropIds` is omitted the API returns the full crop catalogue. The page
// fetches once on mount with no ids and reuses the cached map across drawer
// opens, so the badge logic and pre-population work even for crops the user
// hasn't loaded into a scenario yet.
export const useGetSoilSightCropDatabase = (cropIds?: string[]) => {
  const isAuthenticated = useIsAuthenticated();
  const sortedIds = cropIds ? [...cropIds].sort((a, b) => a.localeCompare(b)) : null;
  const queryKey = [GET_SOIL_SIGHT_CROP_DATABASE, sortedIds];

  return useQuery<SoilSightCropDefaultsByCropId>({
    queryKey,
    queryFn: () => getSoilSightCropDatabase(sortedIds ?? undefined),
    // Defaults rarely change; cache aggressively to keep drawer opens snappy.
    staleTime: 1000 * 60 * 30,
    enabled: isAuthenticated,
  });
};
